import { SortDirection } from '@/modules/drivers/types/table'
import * as React from 'react'
import Sort from '../../../../assets/icons_new/SortColorBlue.svg'
export const TableSortIcon = ({
  className,
  sortDirection,
  hover = false,
}: {
  hover: boolean
  className?: string
  sortDirection: SortDirection
}) => {
  return (
    <div>
      <div className="tw-rounded-full tw-bg-secondary">
        {sortDirection === 'asc' && <img src={Sort} />}
      </div>
      {!sortDirection && (
        <>
          {hover ? (
            <div className="tw-rounded-full tw-bg-gray-200">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={className}
              >
                <g opacity="0.8">
                  <path
                    d="M8.46875 2.66406L12.2188 5.66406C12.5234 5.94531 12.5938 6.41406 12.3359 6.71875C12.0547 7.04688 11.5859 7.09375 11.2812 6.83594L8 4.21094L4.71875 6.83594C4.39062 7.09375 3.92188 7.04688 3.66406 6.71875C3.40625 6.41406 3.45312 5.92188 3.78125 5.66406L7.53125 2.66406C7.78906 2.45312 8.1875 2.45312 8.46875 2.66406ZM12.2188 11.3359L8.46875 14.3359C8.1875 14.5703 7.78906 14.5703 7.53125 14.3359L3.78125 11.3359C3.45312 11.0781 3.38281 10.6094 3.66406 10.2812C3.92188 9.97656 4.39062 9.90625 4.71875 10.1641L8 12.7891L11.2812 10.1641C11.5859 9.90625 12.0781 9.97656 12.3359 10.2812C12.5938 10.6094 12.5234 11.0781 12.2188 11.3359Z"
                    fill="black"
                  />
                </g>
              </svg>
            </div>
          ) : (
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={className}
            >
              <g opacity="0.8">
                <path
                  d="M8.46875 2.66406L12.2188 5.66406C12.5234 5.94531 12.5938 6.41406 12.3359 6.71875C12.0547 7.04688 11.5859 7.09375 11.2812 6.83594L8 4.21094L4.71875 6.83594C4.39062 7.09375 3.92188 7.04688 3.66406 6.71875C3.40625 6.41406 3.45312 5.92188 3.78125 5.66406L7.53125 2.66406C7.78906 2.45312 8.1875 2.45312 8.46875 2.66406ZM12.2188 11.3359L8.46875 14.3359C8.1875 14.5703 7.78906 14.5703 7.53125 14.3359L3.78125 11.3359C3.45312 11.0781 3.38281 10.6094 3.66406 10.2812C3.92188 9.97656 4.39062 9.90625 4.71875 10.1641L8 12.7891L11.2812 10.1641C11.5859 9.90625 12.0781 9.97656 12.3359 10.2812C12.5938 10.6094 12.5234 11.0781 12.2188 11.3359Z"
                  fill="currentColor"
                />
              </g>
            </svg>
          )}
        </>
      )}

      <div className="tw-rounded-full tw-bg-secondary">
        {sortDirection === 'desc' && (
          <img src={Sort} className="tw-rotate-180" />
        )}
      </div>
    </div>
  )
}
